<template>
	<div class="basic_wrap">
		<div class="login_bg"></div>
		<div class="top">
			<div class="top1">
				<span>欢迎来到{{name}}</span>
				<div class="language" @click="$router.push('/language')">
					<img :src="require('../images/language/'+lang+'.png')" style="width: 30px;height: 30px;">
				</div>
			</div>
		
		</div>
		<form class="form">
			<div class="item">
				<div class="">
					<div style="display: flex; align-items: center;" @click="areaShow = true">
						<span>+{{ data.optionval }}</span>
						<van-icon style="margin-left: 8px;" name="arrow-down" size="14" />
					</div>
				</div>
				<input v-model.trim="data.mobile" maxlength="11" type="text" class="inp"
					:placeholder="$t('userSet.phone')">
			</div>
			<!-- 邮箱 -->
			<div class="item">
				<div class="">
					<div style="display: flex; align-items: center;">
						<span>Email</span>
					</div>
				</div>
				<input v-model.trim="data.email" maxlength="60" type="email" class="inp"
					:placeholder="$t('login.phoneEmpty')">
			</div>
			<div class="item">
				<span class="icon">
					<img src="../../assets/img/msg.png" alt="">
				</span>
				<input v-model.trim="data.email_code" maxlength="6" type="number" class="inp" 
				:placeholder="$t('setpwd.SMSverificationcode')">
				<div v-if="emailTime <= 0" @click="sendcodeEamil" >{{$t('register.sendCode')}}</div>
				<div v-if="emailTime > 0" @click="sendcodeEamil" >{{emailTime}}</div>
				
			</div>


			<div class="item">
				<span class="icon">
					<img src="../../assets/img/pwd.png" alt="">
				</span>
				<input v-model.trim="data.password" :type="password" class="inp" :placeholder="$t('register.password')">
				<div class="eye_bi" :class="password == 'text' ? 'eye' : ''" @click="showPwd" />
			</div>
			<div class="item">
				<span class="icon">
					<img src="../../assets/img/pwd.png" alt="">
				</span>
				<input v-model.trim="data.spassword" :type="password" class="inp" :placeholder="$t('userSet.spwd')">
				<div class="eye_bi" :class="password == 'text' ? 'eye' : ''" @click="showPwd" />
			</div>

			<!-- 			<div class="item">
					  <input type="password" class="inp" v-model.trim="data.paypwd" placeholder="请输入支付密码" />
				  </div>
				  <div class="item">
					  <input type="password" class="inp" v-model.trim="data.confirm_paypwd" placeholder="请再次输入支付密码" />
				  </div> -->

			<div v-if="show_sms > 0" class="item">
				<input v-model.trim="data.code" type="text" class="inp" :placeholder="$t('userSet.invCode')">
				<van-count-down :time="time" class="btn get_captcha" @finish="timeCall">
					<template v-slot="timeData">
						<span @click="sendcode">{{
							timeData.seconds > 0
							? timeData.seconds
							: $t('register.sendCode')
							}}</span>
					</template>
				</van-count-down>
			</div>
			<div class="item">
				<span class="icon">
					<img src="../images/login/p2.png" class="people" alt="">
				</span>
				<input v-model.trim="data.t_mobile" maxlength="6" type="text" class="inp"
					:placeholder="$t('userSet.invCode')">
			</div>
		</form>
		
		<div class="tips">
			<van-checkbox v-model="checprot" checked-color="#8e7d6f">
				{{ $t('userSet.agreen') }}
				<span style="color: #f2e2cc" @click="toProc(12)">《{{ $t('index.agreement') }}》</span>
				<span style="color: #f2e2cc" @click="toProc(13)">《{{ $t('index.secret') }}》</span>》
			</van-checkbox>
		</div>
		
		

		<div class="basic_btn sbtn" :class="
        data.mobile == '' ||
          data.password == ''
		  //||data.code == ''
          ? 'no_touch'
          : ''
      " @click="submit">
			{{ $t('register.signUpBtn') }}
		</div>
		
		<div class="tologin" @click="$router.push('/login')">{{ $t('lang.已有账号,去登录') }}</div>

		<van-dialog v-model="statement" confirm-button-color="#fb661e" :close-on-click-overlay="true"
			@click="privacyStatementHide">
		</van-dialog>
		<van-dialog v-model="agreement" confirm-button-color="#fb661e" :close-on-click-overlay="true"
			@click="agreementHider">
		</van-dialog>
		<div v-if="msg_show" class="kefu" :class="show_kefu ? '' : 'kefu_hide'" @click="kefu_to">
			<img class="kefu_img" style="width:50%;height:50%;" src="../images/index/kefu.png">
		</div>


		<van-action-sheet v-model="areaShow">
			<div class="area-content">
				<div class="area-search">
					<van-icon name="search" size="20" color="#bbbcc1" />
					<input v-model="searchCode" class="flex-1 bg-[#f5f5f5]" type="number"
						:placeholder="$t('lh.搜索国家区号')">
				</div>
				<div class="area-list">
					<div class="area-item" v-for="item in filterAreaList" @click="selectArea(item)">{{ item.name }}(+{{
						item.mobilePrefix }})
					</div>
				</div>
			</div>
		</van-action-sheet>
	</div>
</template>

<script>
	import Vue from "vue";
	import { CountDown, Checkbox, Dialog, } from "vant";
	import Fetch from "../../utils/fetch";
	import areaCode from '@/utils/areaCode';

	Vue.use(CountDown)
		.use(Checkbox)
		.use(Dialog);

	export default {
		name: "Register",
		data() {
			return {
				lang: this.$i18n.locale || "zh_cn",
				emailTime: 0,
				time: 0,
				agreement: false,
				statement: false,
				show_kefu: false,
				msg_show: true,
				show_sms: 0,
				password: "password",
				data: {
					optionval: '86',
					password: "",
					spassword: "",
					mobile: "",
					email_code: "",
					email: "",
					t_mobile: "",
					code: "",
					agent: 10000
				},
				config: {},
				checprot: false,
				areaShow: false,
				searchCode: '',
				title: "",
				name: "",
			};
		},
		computed: {
			filterAreaList() {
				return areaCode.filter(item => item.mobilePrefix.includes(this.searchCode));
			}
		},
		created() {
			this.$parent.footer("user", false);
			this.getparams();
			if (this.$route.query.inviteCode) {
				this.data.t_mobile = this.$route.query.inviteCode
			}
			// 安卓返回IMEI，苹果返回UID值
			/*BSL.PhoneID('callName');
				window.callName = this.methodName;
				// 获取手机OAID
				BSL.GetOAID('getExternalInfo');
				window.getExternalInfo = this.getExternalInfoData; */
		},
		mounted() {

			if (this.$route.query.agent) {
				localStorage.setItem('agent', this.$route.query.agent);
				this.data.agent = this.$route.query.agent;
			} else {
				if (localStorage.getItem('agent')) {
					this.data.agent = localStorage.getItem('agent');
				}
			}
			var that = this;
			document.body.addEventListener(
				"scroll",
				function () {
					if (!that.show_kefu) {
						return;
					}
					that.show_kefu = false;
				},
				false
			);
			document.addEventListener(
				"click",
				function (ev) {
					if (ev.target.className != "kefu_img") {
						that.show_kefu = false;
					}
				},
				false
			);
			Fetch('/index/webconfig', { type: 'web' }).then(res => {
				this.config = res.data
				this.show_sms = res.data.sms_verify
			})
			that.start();
		},
		methods: {
			sendcodeEamil(){
				var that = this;
				if (!this.data.email){
					this.$toast(this.$t('register.phoneEmpty'));
					return;
				}
				if ( that.emailTime>0 ){
					this.$toast(this.$t('register.phoneEmpty'));
					return;
				}
				
				Fetch("/index/sendEamilCode", {
					email: this.data.email,
				})
				.then(() => {
					that.emailTime = 60;
					that.$toast({
						background: "#07c160",
						message: this.$t('register.sendSuccess'),
					});

					const interval = setInterval(() => {
						// 更新显示
						
						if (that.emailTime <= 0) {
							clearInterval(interval); // 停止计时
							that.emailTime = 0;
						} else {
							that.emailTime--; // 减少倒计时时间
						}
					}, 1000); // 每秒更新

				})
				.catch(() => {
					this.is_send = false;
				});
				

			},
			start() {
				Fetch("/index/webconfig").then((r) => {
					this.name = r.data.web_name;
					this.title = r.data.title;
				});
				this.sync_timer = setInterval(() => {
					this.sync()
				}, 3000);
			},
			selectArea(item) {
				this.data.optionval = item.mobilePrefix;
				this.areaShow = false;
				this.searchCode = "";
			},
			toProc(id) {
				this.$router.push('/about/' + id)
			},
			kefu_to() {
				if (this.show_kefu) {
					this.$router.push("/kefu");
				}
				this.show_kefu = !this.show_kefu;
			},
			showPwd() {
				if (this.password == "password") {
					this.password = "text";
				} else {
					this.password = "password";
				}
			},
			methodName(r) {
				this.data.imei = r;
			},
			getExternalInfoData(info) {
				var info = JSON.parse(info);
				console.log(info);
				if (info.code == 0) {
					this.data.oaid = info.oaid;
				}
			},
			getparams() {
				var m = this.$route.query.m;
				this.data.t_mobile = m;
			},
			timeCall() {
				this.is_send = false;
				this.time = 0;
			},
			sendcode() {
				if (this.is_send) {
					return;
				}

				if (!this.data.mobile) {
					this.$toast(this.$t('register.phoneEmpty'));
					return;
				}

				this.is_send = true;

				Fetch("/index/register_code", {
					mobile: this.data.mobile,
				})
					.then(() => {
						this.time = 60 * 1000;
						this.$toast({
							background: "#07c160",
							message: this.$t('register.sendSuccess'),
						});
					})
					.catch(() => {
						this.is_send = false;
					});
			},
			submit() {
				if (!this.data.mobile) {
					this.$toast(this.$t('userSet.phone'));
					return false;
				}
				if (!this.data.email) {
					this.$toast(this.$t('userSet.phoneEmpty'));
					return false;
				}
				if (!this.data.email_code) {
					this.$toast(this.$t('authEmail.codeEmpty'));
					return false;
				}
				if (!this.data.password) {
					this.$toast(this.$t('register.passwordEmpty'));
					return false;
				}
				// if (!this.data.spassword) {
				//     this.$toast(this.$t('register.passwordAgainEmpty'));
				//     return false;
				// }
				if (!this.data.t_mobile) {
					this.$toast(this.$t('userSet.invCode'));
					return false;
				}
				if (this.data.t_mobile.length != 6) {
					this.$toast(this.$t('userSet.invCodeT'));
					return false;
				}

				if (!this.data.code && this.config.sms_verify) {
					this.$toast(this.$t('register.codeEmpty'));
					return false;
				}
				if (!this.checprot) {
					this.$toast(this.$t('userSet.ppp'));
					return false;
				}
				if (this.data.password != this.data.spassword) {
					this.$toast(this.$t('userSet.ww'));
					return false;
				}

				Fetch("/index/register", {
					...this.data,
				}).then((res) => {
					if (res.data.token) {
						localStorage.setItem('token', res.data.token);
					}
					this.$toast(this.$t('register.signUpSuccess'));
					this.$router.replace("/");
				});
			},
			userAgreement() {
				this.agreement = true;
			},
			agreementHider() {
				this.agreement = false;
			},
			privacyStatement() {
				this.statement = true;
			},
			privacyStatementHide() {
				this.statement = false;
			},
		},
	};
</script>

<style lang="less" scoped>
	.area-content {
		padding-top: 1rem;
		padding-left: 1.5rem;
		padding-right: 1.5rem;
		display: flex;
		flex-direction: column;
		height: 33.333333%;

		.area-search {
			padding-left: 0.5rem;
			padding-right: 0.5rem;
			background-color: rgb(245 245 245);
			border-radius: 0.75rem;
			width: 100%;
			height: 2.5rem;
			display: flex;
			align-items: center;
		}

		.area-list {
			overflow-y: scroll;
			height: 15rem;

			.area-item {
				padding-top: 0.75rem;
				padding-bottom: 0.75rem;
				border-bottom-color: rgb(209 213 219);
				border-bottom-width: 1px;
				display: flex;
			}
		}
	}

	/deep/ .van-checkbox__label {
		color: #8e7d6f;
	}

	.tologin {
		color: #f0d9c3;
		text-align: right;
		font-size: .78125rem;
		margin: 20px auto 0 auto;
	}

	.basic_wrap {
		margin: 0 auto;
		width: 100%;
		height: 100vh;
		padding: 10px 24px 0 24px;
		background: url("../../assets/img/login-bg.png") no-repeat;
		background-size: 100% 100%;

		.top {
			color: #f0d9c3;

			.top1 {
				display: flex;
				justify-content: space-between;
				align-items: center;
				font-size: 1.125rem;
				color: #ecdccf;
				margin-left: 1.15625rem;
				font-weight: 700;
			}

			.top2 {
				font-size: 1.25rem;
				color: #f0d9c3;
				margin-left: 2.4375rem;
				margin-top: 1.25rem;
				font-weight: 700;
			}
		}
	}

	.form {
		margin-top: 3.9375rem;
	}

	.login_bg {
		width: 100%;
		height: 60px;
		overflow: hidden;
		background-size: 100% 100%;

	}

	.language {
		width: 21px;
		height: 21px;

		img {
			width: 100%;
			height: 100%
		}
	}


	.cut_login {
		width: 207px;
		line-height: 25px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 18px;
		text-align: center;
		margin: 0 auto;

		a {
			width: 50%;
			padding-bottom: 10px;
			color: #ceced0;
			position: relative;

			.line {
				width: 100%;
				height: 1px;
				position: absolute;
				left: 0;
				bottom: 0;
				background-color: #f2f2f2;
			}
		}

		a.cur {
			color: #f12211;

			.line {
				height: 2px;
				background-image: linear-gradient(to right, #f12211, #f18a11);
			}
		}
	}

	.mt {
		margin-top: 20px;
	}

	.item {
		//height: 68px;
		font-size: 14px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		//padding-bottom: 4px;
		padding: 10px 10px 4px 10px;
		background: #000000;
		border: 0.0625rem solid #514941;
		border-radius: 0.21875rem;
		color: #f0d9c3 !important;
		margin-bottom: 20px;

		.icon {
			width: 16px;
			height: 16px;

			img {
				width: 100%;
				height: 100%;
			}
		}

		input {
			height: 20px;
			margin-left: 7px;
			flex: 1;
			margin-bottom: 3px;
		}
	}

	.item_reset_pwd {
		font-size: 14px;
		color: #3d96ff;
		text-align: right;
		margin-top: 10px;
		line-height: 20px;
	}

	.van-checkbox {
		margin-top: 20px;
	}

	.reset_pwd {
		color: #3d96ff;
		margin-top: -20px;
		display: block;
	}

	.basic_btn {
		border-radius: 12px;
		margin: 20px auto 0 auto;
		background: linear-gradient(0deg, #AE8B6D 0%, #F1E1D3 100%);
	}

	.tips {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 16px;
		font-size: .625rem;
		color: #8e7d6f;
	}
</style>